module.exports = __webpack_public_path__ + "img/img3.253b80fb.svg";